<div class="min-h-screen bg-rez-bg-primary flex">
  <!-- Left panel — branding -->
  <div
    class="hidden lg:flex flex-col justify-between w-[45%] bg-rez-action-primary p-12">
    <!-- Logo -->
    <div class="flex items-center">
      @if (logoInverseSrc()) {
        <img [src]="logoInverseSrc()" [alt]="appName()" class="w-52 h-auto" />
      } @else {
        <div class="w-10 h-10 rounded-xl bg-rez-primary-80 flex items-center justify-center">
          <mat-icon class="text-rez-text-inverse !text-[22px] !w-[22px] !h-[22px] !leading-none">
            {{ icon() }}
          </mat-icon>
        </div>
        <span class="ml-3 text-rez-text-inverse text-lg font-bold tracking-tight">
          {{ appName() }}
        </span>
      }
    </div>

    <!-- Tagline -->
    <div>
      <h1 class="text-4xl font-bold text-rez-text-inverse leading-snug mb-4">
        {{ tagline() }}
      </h1>
      <p class="text-rez-primary-20 text-base leading-relaxed">
        {{ taglineSubtext() }}
      </p>
    </div>

    <!-- Footer note -->
    <p class="text-rez-primary-8 text-xs">© {{ year }} Rezevent</p>
  </div>

  <!-- Right panel — form -->
  <div class="flex flex-1 items-center justify-center p-8">
    <div class="w-full max-w-sm">
      <!-- Mobile logo -->
      <div class="flex items-center mb-10 lg:hidden">
        @if (logoSrc()) {
          <img [src]="logoSrc()" [alt]="appName()" class="w-44 h-auto" />
        } @else {
          <div class="w-9 h-9 rounded-xl bg-rez-action-primary flex items-center justify-center">
            <mat-icon class="text-rez-text-inverse !text-[20px] !w-[20px] !h-[20px] !leading-none">
              {{ icon() }}
            </mat-icon>
          </div>
          <span class="ml-3 text-rez-text-primary text-base font-bold tracking-tight">
            {{ appName() }}
          </span>
        }
      </div>

      <!-- Heading -->
      <h2 class="text-2xl font-bold text-rez-text-primary mb-1">
        {{ welcomeTitle() }}
      </h2>
      <p class="text-sm text-rez-text-muted mb-8">{{ welcomeSubtitle() }}</p>

      <!-- Error -->
      @if (error$ | async; as error) {
        @if (error) {
          <div
            class="flex items-center gap-2 px-4 py-3 mb-5 rounded-lg bg-rez-error-0 border border-rez-error-8 text-rez-action-danger text-sm">
            <mat-icon>error_outline</mat-icon>
            <div>{{ error }}</div>
          </div>
        }
      }

      <!-- Fields -->
      <div class="flex flex-col gap-5">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Email</mat-label>
          <input
            matInput
            [formControl]="ctrls.email"
            type="email"
            autocomplete="email" />
          @if (ctrls.email.touched && ctrls.email.invalid) {
            <mat-error>{{ emailError() }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Password</mat-label>
          <input
            matInput
            [formControl]="ctrls.password"
            type="password"
            autocomplete="current-password" />
          @if (ctrls.password.touched && ctrls.password.invalid) {
            <mat-error>{{ passwordError() }}</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Submit -->
      <button
        mat-flat-button
        class="w-full !bg-rez-action-primary !text-rez-text-inverse !font-medium !mt-7 !py-3 !h-auto"
        [disabled]="loading$ | async"
        (click)="login()">
        @if (loading$ | async) {
          <mat-spinner diameter="18" class="inline-block mr-2" />
        }
        {{ submitLabel() }}
      </button>
    </div>
  </div>
</div>
